export default __webpack_public_path__ + "static/simple-doughnut-a1a250b83816f504fd33d26d9dafa599.png";